import * as React from "react";
import { useState } from "react";
import styled from "styled-components";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  MbjCard,
  MbjCardBody,
  MbjCardHeader,
  MbjHeading,
  MbjListItem,
  MbjLoading,
  MbjNavPath,
  MbjScrollArea,
  MbjSearchBar,
  MbjWidgetClassic,
} from "@mbj-front-monorepo/ui";
import { MobilitesByMbjCard } from "./MobilitesByMbjCard/MobilitesByMbjCard";
import { MobilitesSavedCard } from "./MobilitesSavedCard/MobilitesSavedCard";
import { useGetEmployee, useGetMetiers } from "@mbj-front-monorepo/data-access";

interface MobilitesCtrlProps {
  className?: string;
}

function MobilitesCtrl(props: MobilitesCtrlProps) {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const employeeQuery = useGetEmployee(parseInt(id || "-1"));
  const metiersQuery = useGetMetiers();
  const [search, setSearch] = useState<string>("");

  const ListeMetiersFiltered = React.useMemo(() => {
    if (metiersQuery.isLoading || metiersQuery.isError || !metiersQuery.data) {
      return [];
    }
    return metiersQuery.data
      ?.filter((metier) => {
        if (search === "") {
          return metier;
        } else if (metier.libelle?.toLowerCase().includes(search.toLowerCase())) {
          return metier;
        }
        return undefined;
      })
      .sort((a, b) => {
        return (a.libelle || "0") > (b.libelle || "0") ? 1 : -1;
      });
  }, [metiersQuery.data, metiersQuery.isLoading, metiersQuery.isError, search]);

  return (
    <div className={"Mobilites " + props.className}>
      {employeeQuery.isLoading ? (
        <MbjLoading />
      ) : employeeQuery.isError ? (
        <p>Erreur ...</p>
      ) : (
        <>
          <MbjNavPath
            routePath={location.pathname}
            changeLabelTab={[
              {
                index: 2,
                label: employeeQuery.data?.nom?.toUpperCase() + " " + employeeQuery.data?.prenom,
              },
              { index: 3, label: "Mobilités" },
            ]}
          />
          <MbjWidgetClassic title={"Mobilité vers un métier précis"} bodyDirection={"column"}>
            <MbjSearchBar
              placeholder={"Rechercher un métier"}
              className={"SearchBar"}
              onChange={(event) => setSearch(event.target.value)}
            />
            <MbjCard className={"searchResult"} margBott={"12px"}>
              <MbjCardHeader>
                <MbjHeading>Nombre de métiers : {ListeMetiersFiltered.length}</MbjHeading>
              </MbjCardHeader>
              <MbjCardBody noPadding>
                <MbjScrollArea maxHeight={"150px"}>
                  {ListeMetiersFiltered.map((item, idx) => (
                    <MbjListItem key={item.id} to={location.pathname + "/" + item.id}>
                      {item.libelle}
                    </MbjListItem>
                  ))}
                </MbjScrollArea>
              </MbjCardBody>
            </MbjCard>
          </MbjWidgetClassic>
          <MbjWidgetClassic title="Mobilités selon le profil" grow={1} bodyGrow={1}>
            <MobilitesByMbjCard basis={"calc(50% - 12px)"} />
            <MobilitesSavedCard id={parseInt(id as string)} basis={"calc(50% - 12px)"} />
          </MbjWidgetClassic>
        </>
      )}
    </div>
  );
}
export const Mobilites = styled(MobilitesCtrl)((props) => ({
  padding: "1% 2%",
  height: "100%",
  display: "flex !important",
  flexDirection: "column",

  ".searchResult": {
    ".MbjCardHeader": {
      borderBottom: `1px solid ${props.theme.primaryLighten}`,
    },
  },
}));
